import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigurationService } from '@common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class BtlBattlefrontService {
    constructor(private http: HttpClient, private configService: ConfigurationService) {}

    private cache: { [key: string]: string } = {};

    public getBlock(blockId: string): Observable<any> {
        const cacheValue = this.cache[blockId];
        if (!!cacheValue) {
            return of({ html: cacheValue });
        }

        const uri = `${this.configService.getData()?.global?.cms.battlefront}/${blockId}`;

        return this.http.get(uri, { responseType: 'text' }).pipe(
            map((response) => {
                this.cache[blockId] = response;
                return { html: response };
            }),
        );
    }

    public getBtaBlock(blockId: string): Observable<{ html: any }> {
        const cacheValue = this.cache[blockId];
        if (!!cacheValue) {
            return of({ html: cacheValue });
        }

        const uri = `${this.configService.getData()?.global?.cms.bta}/${blockId}`;

        return this.http.get(uri, { responseType: 'text' }).pipe(
            map((response) => {
                this.cache[blockId] = response;
                return { html: response };
            }),
        );
    }
}
